import { CPET_INFO_ENDPOINT } from "../../endpoints";
import { Nullable, WithErrors } from "../../types";
import { fetcher } from "../../utils";
import { CPETInformation } from "./types";

export const getCPETInfo = async ({ testId }: { testId: string }) => {
    const response = await fetcher(CPET_INFO_ENDPOINT, {
        params: { test_id: testId },
    });

    return response as Nullable<WithErrors<CPETInformation>>;
};

export const submitCPETInfo = async ({
    testId,
    values,
}: {
    testId: string;
    values: CPETInformation;
}) => {
    const response = await fetcher(
        CPET_INFO_ENDPOINT,
        {
            method: "PUT",
            body: JSON.stringify(values),
            headers: {
                "Content-Type": "application/json",
            },
            params: { test_id: testId },
        },
        true
    );

    return response as Nullable<WithErrors<CPETInformation>>;
};
